/**
 * This is the interface definition file for all data stores
 * 
 * In each env, it will decide to use some kinds of datastore to populate the data
 */

class BaseDataStore {
    /**
     * 
     * @param {String} url something like: /package/:id, /library/:id, /packages, 
     */
    getData(url) {
        debugger
        throw new Error("Not Implemented");
    }



}


module.exports = BaseDataStore;